
import { ReactComponent as SaabSvg } from './saab.svg';

const Saab = () => (
    <div className="companyName">
        <SaabSvg/>
    </div>
        )

export default Saab;
